module.exports = __webpack_public_path__ + "static/media/percentage.9c4ee1c4.svg";